import Vehicles from '../../services/vehicles'
import Tag from '../../services/tag'
import Pagination, {Page} from '../../components/pagination'

const pageSize = 10;

export default {
  data() {
    return {
      data: undefined,
      page: new Page(),
      state: 'LOADING',
      filter: '',
      loading: false,
      vehiclesChecked:[]
    }
  },

  mounted() {
    this.find();
  },

  computed:{
    contractId() {
      return this.$route.params.contractId;
    }
  },

  methods: {
    setCurrentPage(p) {
      this.page = this.page.page(p);
      this.find();
    },

      setPageSize(size) {
      this.page = this.page.size(size);
      this.find();
    },
    find() {
      this.state = 'LOADING';
      let filter = {
        contractId: this.contractId,
           page: {
          pageSize: this.page.size(),
          pageNumber: this.page.page()
        }
      };

      this.loading = Vehicles.getVehicle(filter)
        .then(data => {
          if (data) {
            this.data = data;
            this.state = this.data.itens && 'LOADED' || 'NOTFOUND';
            this.page = this.page.itemCount(data.total);

            for (let v of this.data.itens) {
              if (v.enabledPap == 'Y')
              this.vehiclesChecked.push(v.vehicleId);
            }
          }
        })
        .catch(err => {
          this.state = 'NOTFOUND';
          let msg = err.data && err.data.status && err.data.status.message || "Erro do servidor.";
        })
    },
    tooglePtoP(itens) {
      itens.requestReplaceTag = 'N';

      let enabledPap;

      if (itens.enabledPap) {
       enabledPap = itens.enabledPap;
      } else {
        enabledPap = 'N';
      }

      if (enabledPap == 'Y') {
        enabledPap = 'N';
      } else if(enabledPap == 'N') {
        enabledPap = 'Y';
      }
       let options = {
        placement:'top',
        html:true,
        delay: { "show": 500, "hide": 300 },
        // content:  vehicle.enabledPAP == 'Y' ? 'Veículo excluído com sucesso!' : 'Veículo incluído com sucesso!',
        content:  enabledPap == 'Y' ? 'Veículo incluído com sucesso!' : 'Veículo excluído com sucesso!',
        animation:true,
        template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
       }

      let vehicleId = itens.vehicleId;

      this.loading = Vehicles.updateVehicle(enabledPap,vehicleId).then(()  => {

        $('#' + itens.vehicleId).popover(options);
         $('#' + itens.vehicleId).popover('show');

          setTimeout(function(){
            $('#' + itens.vehicleId).popover('destroy');
           }, 2000);

        this.find();
      }).catch(()=>{
        options.content = 'Erro ao processar requisição'
        $('#' + itens.vehicleId).popover(options);
         $('#' + itens.vehicleId).popover('show');

          setTimeout(function(){
            $('#' + itens.vehicleId).popover('destroy');
           }, 2000);
      });
    }

  },
  components: {
    Pagination
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/vehicles-p-to-p.js